import type { ReactNode } from "react";
import { Button, Checkbox, Popover } from "@/ui";

interface Props<K extends string> {
  /** 按钮的名称，如“筛选条件”“显示列”；按钮只显示图标，名称用作无障碍名称与悬停提示。 */
  label: string;
  /** 按钮上的图标（ToolIcon）。 */
  icon: ReactNode;
  /** 面板顶部的小标题。 */
  heading: string;
  /** 全部可选项，按页面上的顺序。 */
  options: { key: K; label: string }[];
  shown: K[];
  onChange: (keys: K[]) => void;
}

/** 列表页工具栏的显示设置：只有图标的按钮打开下拉面板，逐项勾选显示哪些筛选条件或表格列，勾选即生效；面板与按钮左对齐，右侧放不下时由 Popover 翻到右对齐（#513，决策 D187、D198）。 */
export function ShowPicker<K extends string>({ label, icon, heading, options, shown, onChange }: Props<K>) {
  return (
    <Popover trigger={<Button size="sm" iconOnly aria-label={label} title={label}>{icon}</Button>}>
      <div className="ax-menu-label">{heading}</div>
      <div className="ax-stack" style={{ gap: "var(--space-2)", padding: "var(--space-1) var(--space-2) var(--space-2)" }}>
        {options.map((o) => (
          <Checkbox key={o.key} label={o.label} checked={shown.includes(o.key)} onChange={(on) => onChange(on ? [...shown, o.key] : shown.filter((k) => k !== o.key))} />
        ))}
      </div>
    </Popover>
  );
}
